import {TableItem} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/TableItem";
import {RowItemOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/TableControl.Options";
import {ColumnItem} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/ColumnItem";

export class RowItem {
    public Row:HTMLTableRowElement;
    public ColumnItems:ColumnItem[];
    constructor(public TableItem:TableItem,public Options:RowItemOptions){

    }

    Generate(container:HTMLTableRowElement=null) {
        if(this.Row==null)
            if(container!=null)
                this.Row=container;
            else
            {
                this.Row=document.createElement('tr');
                this.TableItem.Table.appendChild(this.Row);
            }
        this.ColumnItems=[];
        for(let column of this.Options.Columns)
        {
            let currentColumn=new ColumnItem(this,column);
            this.ColumnItems.push(currentColumn);
            currentColumn.Generate();
        }


    }

    public Remove(){
        this.Row.remove();
    }

    RemoveColumnAtIndex(indexOfColumn: number) {
        this.ColumnItems[indexOfColumn].Remove();
        this.ColumnItems.splice(indexOfColumn,1);
        this.Options.Columns.splice(indexOfColumn,1);

    }
}